import { Accordion, AccordionDetails, AccordionSummary, Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, LinearProgress, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';
import Global from '../../../customlib/Global';
import Api from '../../../customlib/Api';
import axios from 'axios';
import moment from 'moment';
import { Chat, ExpandMore, FactCheck, Save } from '@mui/icons-material';
import DateRangePickerRich from '../../../customlib/DateRangePickerRich';
import AnalyseDataCancelDialog from './AnalyseDataCancelDialog';
import MessageList from '../../MessageList';
import CreateTicketDataCancelDialog from './CreateTicketDataCancelDialog';

class WhyAnalysisDataCancel extends Component {
    state = { 
        startDate: moment(),
        endDate: moment(),
        dataCancelList: [],
        isLoading: false,
        page: 0,
        rowsPerPage: 10,
        totalRecord: 0,
        isDialogOpen: false,
        selectedData: null,
        isSubmiting: false,
        errorMessage: "",
        isLoadingAnalisa: false,
        currentConversation: null,
        showSnackbar: false,
        snackbarMessage: ""
    } 

    handleDateChanged = (dateRange) => {
        if(dateRange && dateRange[0] && dateRange[1]){
            this.setState({startDate: dateRange[0], endDate: dateRange[1]}, () => {
                this.reloadAll();
            })
        }
    }

    handleOpenChat = (data) => {
        const conversation = Global.generateItemConversation(data);
        this.setState({currentConversation: conversation})
    }

    reloadAll = () => {
        this.loadDataCancelList();
    }

    loadDataCancelList = () => {
        this.setState({isLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    userId: Global.get().user.id,
                    page: this.state.page+1,
                    rowsPerPage: this.state.rowsPerPage
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.dataCancelPendingList(), params, Api.getRequestHeader())
                .then((response) => {
                    const responseData = response.data;
                    if(responseData.success === true){
                        this.setState({isLoading: false, dataCancelList: responseData.data.data, totalRecord: responseData.data.recordCount});
                    }else{
                        this.setState({isLoading: false, dataCancelList: []});
                    }
                })
                .catch((error) => {
                    this.setState({isLoading: false});
                    console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    getAnalisaByPhone = (data) => {
        this.setState({isLoadingAnalisa: true}, () => {
            var userData = Global.get();
                const params = {
                    phoneNumber: data.from
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.getAnalisaByPhone(), params, Api.getRequestHeader())
                .then((response) => {
                    const responseData = response.data;
                    if(responseData.success === true){
                        this.setState({isLoadingAnalisa: false, selectedData: responseData.data, isDialogOpen: true}, () => {

                        });
                    }else{
                        this.setState({isLoadingAnalisa: false, isDialogOpen: false}, () => {
                            this.showSnackBar(responseData.message);
                        });
                    }
                })
                .catch((error) => {
                    this.setState({isLoadingAnalisa: false, isDialogOpen: false});
                    console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    showSnackBar = (message) => {
        this.setState({showSnackbar: true, snackbarMessage: message});
    }

    saveAnalisa = (data) => {
        console.log("DATA", data);
        this.setState({isSubmiting: true}, () => {
            var userData = Global.get();
                const params = {
                    phoneNumber: data?.from,
                    waContactObjectId: data?._id,
                    groupReason: data?.groupReason,
                    reason: data?.reason,
                    appProfileId: Global.getAppProfile()._id,
                    why1: data?.why1 ?? "-",
                    why2: data?.why2 ?? "-",
                    why3: data?.why3 ?? "-",
                    why4: data?.why4 ?? "-",
                    why5: data?.why5 ?? "-",
                    feedback: data?.feedback ?? "-"
                }
                
                if(params.groupReason === null || params.groupReason === undefined || params.groupReason === ""){
                    this.setState({errorMessage: "Group Alasan harus diisi", isSubmiting: false});
                    return;
                }
                
                if(params.reason === null || params.reason === undefined || params.reason === ""){
                    this.setState({errorMessage: "Alasan harus diisi", isSubmiting: false});
                    return;
                }
            
                axios
                .post(Api.saveLeadAnalysis(), params, Api.getRequestHeader())
                .then((response) => {
                    const responseData = response.data;
                    if(responseData.success === true){
                        this.setState({isLoading: false, isSubmiting: false, isDialogOpen: false}, () => {
                            this.showSnackBar(responseData.message);
                            this.reloadAll();
                        });
                    }else{
                        this.setState({isLoading: false, errorMessage: responseData.message});
                    }
                })
                .catch((error) => {
                    this.setState({isLoading: false, errorMessage: error});
                    console.error("There was an error!", userData.user.id, error);
                });
        });
    }
    
    handleChangePage = (event, newPage) => {
        console.log("NEWPAGE : ", newPage);

        // var isNavigateToNewPage = newPage >= this.state.dataCancelList.length/this.state.rowsPerPage;
        var isNavigateToNewPage = true;

        this.setState({page: newPage}, () => {if(isNavigateToNewPage){this.loadDataCancelList();}});
    };
    
    handleChangeRowsPerPage = (event) => {
        this.setState({page: 0, rowsPerPage: event.target.value});
    };

    componentDidMount() {
        this.loadDataCancelList();
    }

    handleOpenDialog = (selected) => {
        this.setState({selectedData: selected, isDialogOpen: true});
    }

    handleCloseDialog = () => {
        this.setState({isDialogOpen: false, selectedData: null});
    }

    render() { 
        return (
        <Box>
            {/* <Grid container spacing={1}>
                <Grid item xs={10}></Grid>
                <Grid item xs={2}>
                    <DateRangePickerRich title={"Tanggal Transaksi"} startDate={this.state.startDate} endDate={this.state.endDate} onDateChanged={this.handleDateChanged} />
                </Grid>
            </Grid> */}
            <Snackbar
                open={this.state.showSnackbar}
                autoHideDuration={6000}
                onClose={() => this.setState({showSnackbar: false})}
                message={this.state.snackbarMessage}
            />
            {
                !this.props.isMobile && (
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 650}}>
                            <TableHead >
                                <TableCell>No</TableCell>
                                <TableCell sx={{minWidth: "120px"}}>Tanggal Lead</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Nama</TableCell>
                                <TableCell>No Telp</TableCell>
                                <TableCell sx={{minWidth: "220px"}}>Kategori Produk</TableCell>
                                <TableCell sx={{minWidth: "150px"}}>Est Delivery</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Occasion</TableCell>
                                <TableCell sx={{minWidth: "150px"}}>City</TableCell>
                                <TableCell sx={{minWidth: "120px"}}>Kategori Masalah</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Sub Kategori</TableCell>
                                {/* <TableCell sx={{minWidth: "200px"}}>Why 1</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 2</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 3</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 4</TableCell>
                                <TableCell sx={{minWidth: "200px"}}>Why 5</TableCell> */}
                                {/* <TableCell>Lihat Chat</TableCell> */}
                                {/* <TableCell sx={{minWidth: "200px"}}>Feedback/Solusi</TableCell> */}
                                <TableCell sx={{minWidth: "100px"}}>Action</TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    this.state.isLoading && (
                                        <TableRow>
                                            <TableCell colSpan={11}>
                                                <LinearProgress />
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                {
                                    this.state.dataCancelList?.map((item, index) => {
                                        return (
                                            <TableRow hover sx={{fontSize: "10px"}}>
                                                <TableCell>{index+1 + ((this.state.page)*this.state.rowsPerPage)}</TableCell>
                                                <TableCell>{Global.formatDateTimeToStrDate(item.created_at)}</TableCell>
                                                <TableCell>{item.fromName}</TableCell>
                                                <TableCell>{item.from}</TableCell>
                                                <TableCell>{item.productCategory}</TableCell>
                                                <TableCell>{Global.formatDateTimeToStrDateTime24(item.deliveryDate)}</TableCell>
                                                <TableCell>{item.occasion}</TableCell>
                                                <TableCell>{item.cityName}</TableCell>
                                                <TableCell>{item.groupReason ?? ""}</TableCell>
                                                <TableCell>{item.reason ?? ""}</TableCell>
                                                {/* <TableCell>{item.why1 ?? ""}</TableCell>
                                                <TableCell>{item.why2 ?? ""}</TableCell>
                                                <TableCell>{item.why3 ?? ""}</TableCell>
                                                <TableCell>{item.why4 ?? ""}</TableCell>
                                                <TableCell>{item.why5 ?? ""}</TableCell> */}
                                                {/* <TableCell>Lihat Chat</TableCell> */}
                                                {/* <TableCell>{item.feedback ?? ""}</TableCell> */}
                                                <TableCell>
                                                    <Tooltip title={"Analisa"}>
                                                        <IconButton color='primary' size='small' onClick={() => this.getAnalisaByPhone(item)}><FactCheck /></IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={"Lihat Chat"}>
                                                        <IconButton onClick={() => this.handleOpenChat(item)} color='secondary' size='small'><Chat /></IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50, 75, 100]}
                                            component="div"
                                            count={this.state.totalRecord}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onPageChange={this.handleChangePage}
                                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={3}></TableCell>
                                    <TableCell colSpan={4}>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50, 75, 100]}
                                            component="div"
                                            count={this.state.totalRecord}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onPageChange={this.handleChangePage}
                                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                )
            }
            
            {
                this.props.isMobile && (
                    this.state.dataCancelList?.map(item => {
                        return <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                            <Box>
                                <strong>{item.fromName}</strong>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>{Global.maskPhoneNumber(item.from)}</Grid>
                                    <Grid item xs={6} textAlign={"right"}>{Global.formatDateTimeToStrDate(item.created_at)}</Grid>
                                    <Grid item xs={12}>{item.productCategory}</Grid>
                                </Grid>
                            </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>{Global.formatDateTimeToStrDateTime24(item.deliveryDate)}</Grid>
                                    <Grid item xs={12}>{item.occasion}</Grid>
                                    <Grid item xs={12}>{item.cityName}</Grid>
                                    <Grid item xs={12}>{item.groupReason}</Grid>
                                    <Grid item xs={12}>{item.reason}</Grid>
                                    <Grid item xs={12} textAlign={"right"}>
                                        <Tooltip title={"Analisa"}>
                                            <IconButton color='primary' size='small' onClick={() => this.getAnalisaByPhone(item)}><FactCheck /></IconButton>
                                        </Tooltip>
                                        <Tooltip title={"Lihat Chat"}>
                                            <IconButton onClick={() => this.handleOpenChat(item)} color='secondary' size='small'><Chat /></IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>;
                    })
                    
                )
            }

            {
                this.props.isMobile && (
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 75, 100]}
                        component="div"
                        count={this.state.totalRecord}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                )
            }

            {
                this.state.isDialogOpen && 
                    <AnalyseDataCancelDialog errorMessage={this.state.errorMessage} isDialogOpen={this.state.isDialogOpen} onClose={this.handleCloseDialog} onSubmit={this.saveAnalisa} isSubmiting={this.state.isSubmiting} isLoadingAnalisa={this.state.isLoadingAnalisa} selectedData={this.state.selectedData} />
            }

            <Dialog
                open={this.state.currentConversation !== null}
                // TransitionComponent={Transition}
                // keepMounted
                onClose={() => {this.setState({currentConversation: null})}}
                aria-describedby=""
            >
                <DialogTitle>
                {/* <strong>{this.state.currentConversation.fromName}</strong>
                <br />
                <strong style={{fontSize: "10px"}}>{this.state.currentConversation.fromNumber}</strong> */}
                </DialogTitle>
                <DialogContent style={{height: "100%"}}>
                    {
                        this.state.currentConversation !== null && (
                            <MessageList
                                onUpdateReadCounter = {()=>{}}
                                onNewIncomingMessage={()=>{}}
                                onUpdateConversations={()=>{}}
                                onUpdateCsHelpState={()=>{}}
                                currentConversation={this.state.currentConversation}
                                onUpdateContactLabelState={()=>{}}
                                onClearCurrentConversation = {()=>{}}
                                onUpdateSlow={()=>{}}
                                onUpdateJustRead={()=>{}}
                                onUpdateUnfinishedChat={()=>{}}
                                onResetUnreadCounter={()=>{}}
                                conversationList={[]}
                                logoutHandler={()=>{}}
                                onSaveCustomerName={()=>{}}
                                style={{maxHeight: "70vh", overflowY: "none"}}
                            />
                        )
                    }
                </DialogContent>
                <DialogActions>
                {/* <Button onClick={handleClose}>Disagree</Button>
                <Button onClick={handleClose}>Agree</Button> */}
                </DialogActions>
            </Dialog>
            
        </Box>
        );
    }
}
 
export default WhyAnalysisDataCancel;